export const getMaskPhoneNumber = (input) => {
  return input
    ?.replace(/\D/g, '')
    ?.replace(/(\d{2})(\d)/, '($1) $2')
    ?.replace(/(\d{5})(\d)/, '$1-$2')
    ?.replace(/(-\d{4})\d+?$/, '$1')
}

export const getMaskCPF = (input) => {
  return input
    ?.replace(/\D/g, '')
    ?.replace(/(\d{3})(\d)/, '$1.$2')
    ?.replace(/(\d{3})(\d)/, '$1.$2')
    ?.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}

export const getMaskZipCode = (input) => {
  return input?.replace(/\Dw/g, '')?.replace(/(\d{5})(\d{3})/, '$1-$2')
}

export const hidePhoneNumberDigits = (input) => {
  const digits = input.replace(/\D/g, '')

  const lastFourNumbers = digits.slice(-4)
  return '** * ****-' + lastFourNumbers
}
